'use strict'

angular
  .module('basalteApp')
  .service('EllieIp', [
    '$rootScope',
    '$timeout',
    'BAS_CORE_CLIENT',
    'BasAppDevice',
    'BasCoreConnection',
    EllieIp
  ])

/**
 * @constructor
 * @param $rootScope
 * @param $timeout
 * @param {BAS_CORE_CLIENT} BAS_CORE_CLIENT
 * @param {BasAppDevice} BasAppDevice
 * @param {BasCoreConnection} BasCoreConnection
 */
function EllieIp (
  $rootScope,
  $timeout,
  BAS_CORE_CLIENT,
  BasAppDevice,
  BasCoreConnection
) {
  var _NETWORK_DOWNTIME_MS = 5000

  var CLASS_INPUT_DISABLED = 'bbs-input-disabled'
  var CLASS_BUTTON_DISABLED = 'bbs-button-disabled'

  var _resetButtonTimeout = null

  var css = {}
  css[CLASS_INPUT_DISABLED] = false
  css[CLASS_BUTTON_DISABLED] = false

  this.resetButton = resetButton
  this.getCss = getCss
  this.setInput = setInput
  this.setButton = setButton
  this.isButtonDisabled = isButtonDisabled

  init()

  function init () {
    // On core client devices, we wait for a response from native side
    // while the network changes, which can take anywhere from under
    // a second to up to 10 seconds.
    $rootScope.$on(
      BAS_CORE_CLIENT.EVT_CORE_CLIENT_NETWORK_UPDATED,
      resetButton
    )
  }

  function isButtonDisabled () {

    return css[CLASS_BUTTON_DISABLED]
  }

  function getCss () {

    return css
  }

  function setInput (disabled) {

    css[CLASS_INPUT_DISABLED] = disabled === true
  }

  function setButton (disabled) {

    _clearResetButtonTimeout()
    css[CLASS_BUTTON_DISABLED] = disabled === true
    // Simulate downtime only for core clients running in the browser.
    if (BasAppDevice.isBrowser()) {
      _resetButtonTimeout = $timeout(resetButton, _NETWORK_DOWNTIME_MS)
    }

    BasCoreConnection.setNetworkChanging(disabled === true)
  }

  function resetButton () {

    _clearResetButtonTimeout()
    css[CLASS_BUTTON_DISABLED] = false
    BasCoreConnection.setNetworkChanging(false)
  }

  function _clearResetButtonTimeout () {

    if (_resetButtonTimeout) {

      $timeout.cancel(_resetButtonTimeout)
      _resetButtonTimeout = null
    }
  }
}
